import axios from "axios";
import qs from 'qs';

const API_URL = `${process.env.REACT_APP_API_ENDPOINT}/api/activities`;

class ActivityService {
    postFilter(data) {
        return axios.post(`${API_URL}/filter`, data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    postFilterGroup(data) {
        return axios.post(`${API_URL}/groups`, data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getFilter(id,type) {
        return axios.get(`${API_URL}/getFilter`, {
            params: {
                id: id,
                type:type
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getFilterGroup(macro) {
        return axios.get(`${API_URL}/getFilterGroups`, {
            params: {
                macro: macro,
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getFilterGroupV2(macros,includeOperative,idType) {
        return axios.get(`${API_URL}/getFilterGroupsV2`, {
            params: { macros,includeOperative,idType},
            paramsSerializer: params =>
                qs.stringify(params, { arrayFormat: 'repeat' }),
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    updateActivities(id,activities) {
        return axios.put(`${API_URL}/${id}`, activities, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
}

export default new ActivityService();